import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a8fc376"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedH4 = _resolveComponent("FriedH4");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _directive_wave = _resolveDirective("wave");
    const _directive_tooltip = _resolveDirective("tooltip");
    return _withDirectives((_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({
            position: 'absolute',
            transform: `translateY(${_ctx.top - _ctx.buttonHeight}px)`,
            left: _ctx.left + 'px',
        })
    }, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
            ref: "createCommentButton",
            class: "create-comment-button",
            "data-external": "create-comment-button",
            disabled: _ctx.disabled,
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.createComment && _ctx.createComment(...args)))
        }, [
            _createVNode(_component_FriedH4, { class: "text hidden-xs-and-up" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cc_tooltip_add_comment')), 1)
                ]),
                _: 1
            }),
            _createVNode(_component_FriedIcon, { icon: "create-contextual-comment" })
        ], 8, _hoisted_1)), [
            [_directive_wave]
        ])
    ], 4)), [
        [_directive_tooltip, {
                content: _ctx.tooltipText,
                offset: 16,
                delay: { show: 300, hide: 100 },
            }]
    ]);
}
